<template>
    <div>

        <el-row class="tac" >

            <el-col :span="24">
                <el-menu

                        default-active="2"
                        class="el-menu-vertical-demo"
                        @open="handleOpen"
                        @close="handleClose"
                        background-color="#545c64"
                        text-color="#fff"
                        active-text-color="#ffd04b"
                        router
                >

<!--                    <el-menu-item index="/backStage_Management" >-->
<!--                        <span slot="title" >首页</span>-->
<!--                    </el-menu-item>-->
                    <el-menu-item index="/backStage_Management/About">
                        <span slot="title">关于我们</span>
                    </el-menu-item>
                    <el-menu-item index="/backStage_Management/Product">
                        <span slot="title">产品中心</span>
                    </el-menu-item>
                    <el-menu-item index="/backStage_Management/ContactUs">
                        <span slot="title">联系我们</span>
                    </el-menu-item>
                    <el-menu-item index="/backStage_Management/News">
                        <span slot="title">新闻中心</span>
                    </el-menu-item>
                    <el-menu-item index="/backStage_Management/Mate">
                        <span slot="title">材料中心</span>
                    </el-menu-item>
                    <el-menu-item index="/backStage_Management/Log">
                        <span slot="title">后台操作日志</span>
                    </el-menu-item>
                </el-menu>
            </el-col>
        </el-row>




    </div>
</template>

<script>

    import request from "@/utils/request";
    export default {
        name: "login",
        metaInfo: {
            title: 'Ifcores 管理中心 - 首页 | 南京恒创磁电有限公司 - Powered by MeCMS', // set a title
            meta: [{
                // 设置meta信息
                name: '后台管理',
                content: '后台管理系统，管理数据和功能'
            }],


        },
        data() {
            return {
                img: '',
                codeImg:'',
                src:"",
                captchaId: '',   // 后端需要的响应头中的信息参数
                form: {


                }
            }
        },
        methods: {
            handleOpen(key, keyPath) {
                console.log(key, keyPath);
            },
            handleClose(key, keyPath) {
                console.log(key, keyPath);
            }
        },
        //------登录判断没有登录就
        mounted() {
            request.post("/test/bcd").then(res => {

                if (res.code==401){
                    this.$router.replace("/login")
                }

            })
        }

    }
</script>

<style lang="less" scoped>

    .el-menu{
        height:100vh
    }

</style>